var o = (a, i, e) => new Promise((c, s) => {
  var g = (t) => {
    try {
      n(e.next(t));
    } catch (r) {
      s(r);
    }
  }, l = (t) => {
    try {
      n(e.throw(t));
    } catch (r) {
      s(r);
    }
  }, n = (t) => t.done ? c(t.value) : Promise.resolve(t.value).then(g, l);
  n((e = e.apply(a, i)).next());
});
import { selfAxios as u } from "@oppein/op-utils";
function p(a) {
  return o(this, null, function* () {
    const {
      data: i
    } = yield u.get(
      "/ucenterapi/internal/business/marketRightDetail",
      { params: a }
    );
    return i;
  });
}
export {
  p as getMarketRightDetail
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/ucenterapi/internal/business/marketRightDetail/get.js
// module id = 1834
// module chunks = 67